import { useStore } from 'stores';
import ReactECharts from 'echarts-for-react';

const upColor = '#00da3c';
const downColor = '#ec0000';

export default function Chart() {
  const UserAiSMProfit = useStore((state) => state.UserAiSMProfit); /** 開盤價那些的 */
  const setCurrentSeriesIndex = useStore(
    (state) => state.setCurrentSeriesIndex
  ); /** 開盤價那些的 */
  const dayRange = useStore((state) => state.dayRange);
  let data = splitData(UserAiSMProfit);
  let zoom = dayRange ? 100 - (dayRange / data.values.length) * 100 : dayRange;
  // 範例 https://echarts.apache.org/examples/zh/editor.html?c=candlestick-brush&lang=js
  function calculateMA(dayCount, data) {
    var result = [];
    for (var i = 0, len = data.values.length; i < len; i++) {
      if (i < dayCount) {
        result.push('-');
        continue;
      }
      var sum = 0;
      for (var j = 0; j < dayCount; j++) {
        sum += data.values[i - j][1];
      }
      result.push(+(sum / dayCount).toFixed(3));
    }
    return result;
  }
  // 日期 開盤 收盤 最低 最高
  function splitData(rawData) {
    let categoryData = []; /** 日期 */
    let values = []; /** 價錢 */
    // let volumes = []; /** 交易量 */ 交易量先保留 之後他們要加的話就直接用
    let positions = []; /** 部位 */
    let incomes = []; /** 損益 */
    for (let i = 0; i < rawData.length; i++) {
      const item = rawData[i];
      const date = item[0].replaceAll('/', '-');
      const openingPrice = Number(item[1]); /** 開盤價 */
      const highestPrice = Number(item[2]); /** 最高價 */
      const lowestPrice = Number(item[3]); /** 最低價 */
      const closingPrice = Number(item[4]); /** 收盤價 */
      const volume = Number(item[7]); /** 交易量 */
      const position = Number(item[8]); /** 部位 */
      const income = Number(item[9]); /** 損益 */
      categoryData.push(date);
      values.push([openingPrice, closingPrice, lowestPrice, highestPrice, volume]);
      // volumes.push([i, volume, openingPrice > closingPrice ? 1 : -1]);
      positions.push([i, position, 1]);
      incomes.push([i, income, 1]);
    }
    return {
      categoryData,
      values,
      // volumes,
      positions,
      incomes,
    };
  }

  const option = {
    animation: false,
    // 下方的標籤
    legend: {
      bottom: 10,
      left: 'center',
      data: ['MA5', 'MA10', 'MA30', '部位', '損益'],
      textStyle: {
        color: '#fff',
      },
    },
    tooltip: {
      showContent: true,
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
      },
      formatter: function (params) {
        const seriesIndex = params[0].dataIndex;
        setCurrentSeriesIndex(seriesIndex);
      },
    },
    axisPointer: {
      link: [
        {
          xAxisIndex: 'all',
        },
      ],
      label: {
        backgroundColor: '#777',
      },
    },
    toolbox: {
      show: false,
    },
    brush: {
      xAxisIndex: 'all',
      brushLink: 'all',
      outOfBrush: {
        colorAlpha: 0.1,
      },
    },
    visualMap: {
      show: false,
      seriesIndex: 5,
      dimension: 2,
      pieces: [
        {
          value: 1,
          color: downColor,
        },
        {
          value: -1,
          color: upColor,
        },
      ],
    },
    grid: [
      {
        top: '1%',
        left: '8%',
        right: '5%',
        bottom: '50%',
      },
      {
        top: '55%',
        left: '5%',
        right: '5%',
        bottom: '35%',
      },
      {
        top: '70%',
        left: '5%',
        right: '5%',
        bottom: 60,
      },
    ],
    xAxis: [
      {
        type: 'category',
        data: data.categoryData,
        scale: true,
        boundaryGap: false,
        axisLine: { onZero: false },
        splitLine: { show: false },
        min: 'dataMin',
        max: 'dataMax',
        axisPointer: {
          z: 100,
        },
      },
      {
        type: 'category',
        gridIndex: 1,
        data: data.categoryData,
        scale: true,
        boundaryGap: false,
        splitLine: { show: false },
        axisLabel: { show: false },
        axisTick: { show: false },
        axisLine: { lineStyle: { color: '#777' } },
        splitNumber: 20,
        min: 'dataMin',
        max: 'dataMax',
      },
      {
        type: 'category',
        gridIndex: 2,
        data: data.categoryData,
        scale: true,
        boundaryGap: false,
        axisLine: { onZero: false },
        axisTick: { show: false },
        splitLine: { show: false },
        axisLabel: { show: false },
        min: 'dataMin',
        max: 'dataMax',
      },
    ],
    yAxis: [
      {
        scale: true,
        splitArea: {
          show: true,
        },
      },
      {
        scale: true,
        gridIndex: 1,
        splitNumber: 2,
        axisLabel: { show: false },
        axisLine: { show: false },
        axisTick: { show: false },
        splitLine: { show: false },
        min: function ({ min }) {
          return min > 0 ? 0 : min;
        },
      },
      {
        scale: true,
        gridIndex: 2,
        splitNumber: 2,
        axisLabel: { show: false },
        axisLine: { show: false },
        axisTick: { show: false },
        splitLine: { show: true },
      },
    ],
    dataZoom: [
      {
        type: 'inside',
        xAxisIndex: [0, 1, 2],
        start: zoom,
        end: 100,
      },
    ],
    series: [
      {
        type: 'candlestick',
        data: data.values,
        triggerEvent: true,
        itemStyle: {
          color: upColor,
          color0: downColor,
          borderColor: undefined,
          borderColor0: undefined,
        },
      },
      {
        name: 'MA5',
        type: 'line',
        data: calculateMA(5, data),
        smooth: true,
        showSymbol: false,
        lineStyle: {
          opacity: 0.5,
        },
      },
      {
        name: 'MA10',
        type: 'line',
        data: calculateMA(10, data),
        smooth: true,
        showSymbol: false,
        lineStyle: {
          opacity: 0.5,
        },
      },
      {
        name: 'MA30',
        type: 'line',
        data: calculateMA(30, data),
        smooth: true,
        showSymbol: false,
        lineStyle: {
          opacity: 0.5,
        },
      },
      /*
      {
        name: '交易量',
        type: 'bar',
        xAxisIndex: 1,
        yAxisIndex: 1,
        data: data.volumes,
      },
      */
      {
        name: '部位',
        type: 'bar',
        xAxisIndex: 1,
        yAxisIndex: 1,
        itemStyle: {
          color: '#ff0000',
        },
        data: data.positions.map(function (d) {
          if (d[1] < 0) {
            return {
              value: d,
              itemStyle: {
                color: '#227700',
              },
            };
          }
          return d;
        }),
      },
      {
        name: '損益',
        type: 'line',
        smooth: true,
        showSymbol: false,
        xAxisIndex: 2,
        yAxisIndex: 2,
        data: data.incomes,
        itemStyle: {
          color: '#ff0000',
        },
      },
    ],
  };

  return (
    <div className="h-96 sm:h-chart">
      <ReactECharts option={option} style={{ height: '100%' }} />
    </div>
  );
}
